/**
 * User account state enum.
 * Represents the lifecycle state of a user account.
 *
 * Note: This file intentionally lives under `src/enums/` so the atoms-plugin
 * can auto-discover it (the enum parser scans `** /enums/*.ts` for module projects).
 */
export enum UserState {
  /**
   * Normal user with full access.
   */
  Active = "Active",

  /**
   * User has been invited but hasn't completed onboarding.
   * They can click the magic link to set up their credentials.
   */
  Invited = "Invited",

  /**
   * User is blocked from signing in.
   * Admins can ban users to prevent access.
   */
  Banned = "Banned",
}
